import React, { useEffect } from 'react';
import { CheckCircle } from 'lucide-react';

const PageLayout = ({ children }) => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
    <div className="w-full max-w-3xl bg-white rounded-2xl shadow-sm ring-1 ring-gray-200 p-10">
      {children}
    </div>
  </div>
);

export default function EkycSuccess() {
  useEffect(() => { document.title = 'KYC Submitted | Cogent Platform'; }, []);
  return (
    <PageLayout>
      <div className="text-center">
        <CheckCircle className="mx-auto text-green-600" size={48} />
        <h1 className="mt-4 text-3xl font-semibold text-gray-900">Verification submitted</h1>
        <p className="mt-3 text-gray-600">
          Thank you. Your identity verification has been submitted successfully. Our compliance team
          will review the results. We’ll notify you by email once the checks are complete.
        </p>

        <div className="mt-8 grid gap-3 sm:grid-cols-2">
          <a
            href="/"
            className="w-full text-center rounded-lg bg-indigo-600 px-5 py-3 font-medium text-white hover:bg-indigo-700 transition"
          >
            Return to Homepage
          </a>
          <a
            href="/contact"
            className="w-full text-center rounded-lg bg-gray-100 px-5 py-3 font-medium text-gray-900 hover:bg-gray-200 transition"
          >
            Contact Support
          </a>
        </div>

        <p className="mt-6 text-xs text-gray-500">
          If this wasn't you, please email <span className="font-medium">operations@cogentplatform.com</span>.
        </p>
      </div>
    </PageLayout>
  );
}
